import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'jit-report-question-sequencing',
  templateUrl: './sequencing.component.html',
  styleUrls: ['./sequencing.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
  ],
})
class ReportQuestionSequencingComponent {
  
}

export {
  ReportQuestionSequencingComponent,
};
